import cn from 'classnames';
import IconFilters from '@creditflowresearch/uilib/Icon/IconFilters';
import Button, { type IButtonProps } from '@creditflowresearch/uilib/Button';
import styles from './filtersBtn.module.scss';

// Extra DOM props and `ref` reach the button, so it can be a `Tooltip asChild` trigger
interface IFiltersBtnProps extends Omit<
  IButtonProps,
  'variant' | 'size' | 'icon' | 'onClick' | 'dataTest' | 'className' | 'childrenClassName' | 'ariaLabel' | 'children'
> {
  filtersCount: number,
  onClick: () => void,
  dataTest?: string,
  className?: string,
  label?: string,
  labelClassName?: string,
  desktopIconOnly?: boolean,
}

const FiltersBtn = ({
  filtersCount,
  onClick,
  dataTest = 'filtersButton',
  className,
  label = 'Filters',
  labelClassName,
  desktopIconOnly = false,
  ...buttonProps
}: IFiltersBtnProps) => {
  const resolvedLabel = filtersCount > 0 ? `${ label } (${ filtersCount })` : label;

  return (
    <Button
      { ...buttonProps }
      variant="solid"
      size="S"
      icon={ <IconFilters /> }
      onClick={ onClick }
      dataTest={ dataTest }
      className={ cn(className, styles.btn, { [styles.desktopIconOnly]: desktopIconOnly }) }
      childrenClassName={ cn(styles.childrenWrp, { [styles.desktopIconOnly]: desktopIconOnly }) }
      ariaLabel={ resolvedLabel }
    >
      <span className={ labelClassName }>{ label }</span>
      { filtersCount > 0 && <span className={ styles.counter }>({ filtersCount })</span> }
    </Button>
  );
};

export default FiltersBtn;
